import Api from './api'

const resource = '/users'
export default {
  get(page = 1, role = null) {
    let uri = `${resource}/index?page=${page}`
    uri += role ? `&role=${role}` : ``
    return Api.get(uri)
  },
  active() {
    return Api.get(`${resource}/index?active`)
  },
  show(username) {
    return Api.get(`${resource}/show/${username}`)
  },
  update(username, data) {
    return Api.patch(`${resource}/update/${username}`, data)
  },
  destroy(username) {
    return Api.delete(`${resource}/destroy/${username}`)
  },
  ban(username, data) {
    return Api.patch(`${resource}/ban/${username}`, data)
  },
  unban(username, data) {
    return Api.patch(`${resource}/unban/${username}`, data)
  },
  avatar(username, data) {
    let formData = new FormData();
    if (data.avatar) formData.append('avatar', data.avatar);
    return Api.post(`${resource}/avatar/${username}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}
